export class DisposableContainer {
  private disposables: Array<Disposable> = [];
  public add(disposable: Disposable): void {
    this.disposables.push(disposable);
  }
  public disposeAll(): void {
    for (const disposable of this.disposables) {
      disposable.dispose();
    }
    this.disposables = [];
  }
}
export type Disposable = {
  dispose: () => void;
};